module.exports = __webpack_public_path__ + "media/src/assets/images/credit-card-2757ca86e28ab30c0c57cde499b1a93a.svg";